import { KibSpinningLoader } from '@chewy/kib-overlays-react';
import React from 'react';
import '@chewy/kib-interstitials-styles/dist/styles/kib-spinner.css';
import '@chewy/kib-overlays-styles/dist/styles/kib-spinning-loader.css';

const PageLoader = () => <KibSpinningLoader data-testid="pet-profile-page-loader" />;

export default PageLoader;
